import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import { isOpenHours } from '../services/AvailabilityService';
import { modalWithExit, togglePopup } from '../services/AlertService';
import { trackContact } from '@/views/calculators/services/trackingUtility';
import store from '@/store/store';
import { RESET_CALCULATORS } from '@/store/modules/calculatorContext';
import BuyInsuranceSettings from '../BuyInsuranceSettings';

@Options({
	name: 'ContactComponent',
	components: {},
	computed: mapState<any>({
		productModel: (state) => state.calculatorContext[state.calculatorContext.active].model,
		productCms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
		basketModel: (state) => state.calculatorContext.basket.model,
		basketCms: (state) => state.calculatorContext.basket.cms,
	}),
	props: {
		name: String,
		useBasketModel: { type: Boolean, default: false },
	},
})
export default class ContactComponent extends Vue {
	name: string; // name for tracking
	useBasketModel?: boolean;

	public productModel!: any; // datastructure for user input (store)
	public basketModel!: any; // datastructure for basket
	public productCms!: any; // datastructure for user input (store)
	public basketCms!: any; // datastructure for basket

	public cms: BuyInsuranceSettings; // settings from CMS (store; // settings from CMS (store)
	public model: any = null;

	private hideContactComponent = false;

	public created() {
		this.model = this.useBasketModel ? this.basketModel : this.productModel;
		this.cms = this.useBasketModel ? this.basketCms : this.productCms;
		store.subscribeAction((action, state) => {
			if (action.type === RESET_CALCULATORS) {
				this.hideContactComponent = this.cms.contactHideOnReceipt;
			}
		});
	}

	get showOffer(): boolean {
		return this.cms.contactCompleteOffer;
	}

	get showWrite(): boolean {
		return this.cms.contactCanWrite;
	}

	get showCall(): boolean {
		if (this.cms.contactCanCall) {
			return isOpenHours(this.cms.openForCall, this.cms.closingDaysForCall);
		}
		return false;
	}

	get hide(): boolean {
		return this.hideContactComponent;
	}
	public openModal(phone: boolean) {
		const modal = modalWithExit(this.cms);
		modal.content = this.showCall && phone ? this.cms.contactText : this.cms.contactTextNoCall;
		modal.title = this.cms.contactTitle;
		modal.id = 'contact_popup';
		togglePopup(this.cms, modal);
		trackContact();
	}
}
